import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import ChangeHistorySkeleton from './Skeleton'
import ItemsLoading from '../../../../components/Loaders/ItemsLoading'

import { clearGetChangeHistory, getChangeHistory } from '../../../../modules/actions/tools'
import {
  getChangeHistorySelector,
  getChangeHistoryIsLoadingSelector,
  getChangeHistoryWasLoadedSelector,
  getChangeHistoryErrorSelector
  // getUpdatesHistoryNextSelector
} from '../../../../modules/selectors/tools'

import { generateDetailsText } from './helpers'

import { formatDateDetailed } from '../../../../constants/dates'
import { historyTypesLabel } from '../../../../constants/changeHistory'
import { PLATFORMS_TO_PROVIDER } from '../../../../constants/selectLists/platformList'

import useStyles from './styles'
import useDrawerFormStyles from '../../../../styles/common/drawerForms'

const ChangeHistory = ({ historyType, platform, itemId }) => {
  const dispatch = useDispatch()

  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const historyList = useSelector(getChangeHistorySelector)
  // const nextHistoryList = useSelector(getUpdatesHistoryNextSelector)

  const itemLabel = historyTypesLabel[historyType]

  // const loadMore = () => {
  //   dispatch(
  //     getUpdatesHistory({
  //       item_id: itemId,
  //       provider: PLATFORMS_TO_PROVIDER[platform],
  //       item_type: historyType,
  //       limit: 2,
  //       next: nextHistoryList
  //     })
  //   )
  // }

  useEffect(() => {
    dispatch(
      getChangeHistory({
        item_id: itemId,
        provider: PLATFORMS_TO_PROVIDER[platform],
        item_type: historyType
        // limit: 10
      })
    )
  }, [dispatch, historyType, itemId, platform])

  useEffect(() => {
    return () => {
      dispatch(clearGetChangeHistory())
    }
  }, [dispatch])

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>History</h3>

      <ItemsLoading
        itemsLength={historyList?.length}
        SkeletonComponent={ChangeHistorySkeleton}
        isLoadingSelector={getChangeHistoryIsLoadingSelector}
        wasLoadedSelector={getChangeHistoryWasLoadedSelector}
        errorSelector={getChangeHistoryErrorSelector}
        noDataText="There are no history items to show"
        // wait for BE to adjust the pagination and uncomment when ready:
        // loadMore={nextHistoryList ? loadMore : null}
      >
        {historyList?.map(item => (
          <div key={item.id}>
            <p>{formatDateDetailed(item.created)}</p>
            <p className={classes.details}>{generateDetailsText(item, itemLabel)}</p>
          </div>
        ))}
      </ItemsLoading>
    </section>
  )
}

ChangeHistory.propTypes = {
  historyType: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
  itemId: PropTypes.string
}

export default ChangeHistory
